var map = {
	"./avanti/logo.jpg": 9133,
	"./canon/logo.jpg": 9893,
	"./deermates/logo.jpg": 7635,
	"./eximbanka/logo.jpg": 6047,
	"./grandhotel-brno/logo.jpg": 4526,
	"./skoda/logo.jpg": 9702,
	"./stavebne-konania/logo.jpg": 6007,
	"./sunsense/logo.jpg": 4885,
	"./websupport/logo.jpg": 4716,
	"./zihadielko/logo.jpg": 781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9994;